export default async function captions_ui(lightbox) {

    const caption_find = el => {
        return !el ?
            null :
            el.nodeName === 'FIGURE' ?
                el.querySelector('figcaption') :
                caption_find(el.parentElement);
    }

    const caption_hide = el => {
        caption_find(el)?.classList.add('hidden');
    }

    const caption_show = el => {
        caption_find(el)?.classList.remove('hidden');
    }


    let el;

    lightbox.on('change', () => {
        if (el !== lightbox.pswp.currSlide.data.element) {
            if (typeof el !== 'undefined') caption_show(el);
            el = lightbox.pswp.currSlide.data.element;
            caption_hide(el);
        }
    });

    lightbox.on('destroy', () => {
        caption_show(el);
        el = undefined;
    });
}
